import request from '../../axios/axiosconfig.js'

export function getWarehouse() {
  return request({
    url: '/ps/wareHouseList/getWarehouse',
    method: 'get'
  })
}
export function getArea() {
    return request({
      url: '/ps/common/getArea',
      method: 'get'
    })
}
export function getPsUser() {
  return request({
    url: '/ps/wareHouseList/getPsUser',
    method: 'get'
  })
}
export function addWarehouseRequest(addWarehouseDto) {
  return request({
    url: '/ps/wareHouseList/addWarehouse',
    method: 'post',
    params: addWarehouseDto,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export function getWarehouseInfoById(id) {
  return request({
    url: '/ps/wareHouseList/getWarehouseInfoById/'+id,
    method: 'get'
  })
}
export function updateWarehouse(updateWarehouseDto) {
  return request({
    url: '/ps/wareHouseList/updateWareHouse',
    method: 'post',
    params: updateWarehouseDto,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export function delWarehouse(delWarehouseDto) {
  return request({
    url: '/ps/wareHouseList/delWarehouse',
    method: 'post',
    params: delWarehouseDto,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/warehousemanagement/warehouseList.js